import './PrintContainer.scss';

import React from 'react';

interface PrintContainerProps {
  /** An element that will render at the top of every page when printing. */
  header?: React.ReactNode;
  /** An element that will render at the bottom of every page when printing. */
  footer?: React.ReactNode;
}

/**
 * A component which formats its children for print, and takes optional
 * `header` and `footer` elements as props that will be displayed on every page.
 */
export const PrintContainer: React.FC<PrintContainerProps> = props => {
  return (
    <table className="print-container-table">
      {props.header && (
        <thead>
          <tr>
            <th>{props.header}</th>
          </tr>
        </thead>
      )}
      {props.footer && (
        <tfoot>
          <tr>
            <th>{props.footer}</th>
          </tr>
        </tfoot>
      )}
      <tbody>
        {React.Children.map(props.children, child => {
          return (
            <tr>
              <td>{child}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
